import _ from "lodash";
/**
 *
 */
export function extractSampling1dArray(flattenArray, interval) {
  const samples = flattenArray.filter((v, i) => {
    // 배열의 첫번째/마지막 요소는 필터링 대상에서 제외
    if (i === 0 || i === flattenArray.length - 1) {
      return true;
      // 배열의 interval 간격으로 위치한 요소를 추출한다.
    } else if (i % interval == 0) {
      return true;
    }
    return false;
  });

  // 샘플링된 배열을 반환
  return samples;
}
